import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mt-3" }, "Zoznam objednávok")
], -1)
const _hoisted_4 = { class: "flex justify-content-end align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search mr-2" }, null, -1)
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_Column = _resolveComponent("Column")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_DataTable, {
        rowStyle: $options.rowStyle,
        totalRecords: $data.pagination.totalRecords,
        dataKey: "id",
        value: $data.orders,
        filters: $data.filters,
        "onUpdate:filters": _cache[1] || (_cache[1] = ($event: any) => (($data.filters) = $event)),
        onFilter: $options.onFilter,
        filterDisplay: "row",
        loading: $data.loading,
        globalFilterFields: $data.globalFilterFields,
        stripedRows: "",
        "row-hover": "",
        onPage: $options.onPage,
        lazy: "",
        paginator: "",
        rows: $data.pagination.rows,
        first: $data.pagination.page
      }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IconField, { iconPosition: "left" }, {
              default: _withCtx(() => [
                _createVNode(_component_InputIcon, null, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }),
                _createVNode(_component_InputText, {
                  modelValue: $data.filters['global'].value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($data.filters['global'].value) = $event)),
                  placeholder: "Vyhľadať",
                  onKeydown: _withKeys($options.onFilter, ["enter"])
                }, null, 8, ["modelValue", "onKeydown"])
              ]),
              _: 1
            }),
            ($data.store.user.role.id !== 2)
              ? (_openBlock(), _createBlock(_component_PrimevueButton, {
                  key: 0,
                  label: $data.isFilterActive ? 'Pifema balkóny' : 'Pifema balkóny',
                  class: _normalizeClass(['ml-2', { 'p-button-danger': $data.isFilterActive }]),
                  icon: $data.isFilterActive ? 'pi pi-filter-slash' : 'pi pi-filter',
                  onClick: $options.toggleFilter
                }, null, 8, ["label", "class", "icon", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_Column, {
            field: "orderNumber",
            header: "ID",
            filterField: "orderNumber",
            showFilterMenu: false,
            filterMenuStyle: { width: '1rem' },
            style: {"min-width":"1rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.orderNumber), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          ($data.store.user.role.id !== 2)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 0,
                field: "user.company",
                header: "Firma",
                filterField: "user.company",
                showFilterMenu: false,
                filterMenuStyle: { width: '1rem' },
                style: {"min-width":"1rem"}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.user.company), 1)
                ]),
                filter: _withCtx(({ filterModel, filterCallback }) => [
                  _createVNode(_component_InputText, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    type: "text",
                    onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                    class: "p-column-filter",
                    placeholder: "Hľadať"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          ($data.store.user.role.id !== 2)
            ? (_openBlock(), _createBlock(_component_Column, {
                key: 1,
                field: "user.lastName",
                header: "Odberateľ",
                filterField: "user.lastName",
                showFilterMenu: false,
                filterMenuStyle: { width: '1rem' },
                style: {"min-width":"1rem"}
              }, {
                body: _withCtx((slotProps) => [
                  _createTextVNode(_toDisplayString(slotProps.data.user.lastName) + " " + _toDisplayString(slotProps.data.user.firstName), 1)
                ]),
                filter: _withCtx(({ filterModel, filterCallback }) => [
                  _createVNode(_component_InputText, {
                    modelValue: filterModel.value,
                    "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                    type: "text",
                    onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                    class: "p-column-filter",
                    placeholder: "Hľadať"
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Column, {
            field: "customerName",
            header: "Zákazník",
            filterField: "customerName",
            showFilterMenu: false,
            filterMenuStyle: { width: '1rem' },
            style: {"min-width":"1rem"}
          }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(slotProps.data.customerName), 1)
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_InputText, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                type: "text",
                onKeydown: _withKeys(($event: any) => (filterCallback()), ["enter"]),
                class: "p-column-filter",
                placeholder: "Hľadať"
              }, null, 8, ["modelValue", "onUpdate:modelValue", "onKeydown"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, {
            field: "type.name",
            header: "Zasklenie"
          }),
          _createVNode(_component_Column, {
            field: "state",
            header: "Status",
            showFilterMenu: false,
            filterMenuStyle: { width: '14rem' },
            style: {"min-width":"12rem"}
          }, {
            body: _withCtx(({ data }) => [
              _createVNode(_component_Tag, {
                value: data.state,
                severity: $options.getStateSeverity(data.state)
              }, null, 8, ["value", "severity"])
            ]),
            filter: _withCtx(({ filterModel, filterCallback }) => [
              _createVNode(_component_Dropdown, {
                modelValue: filterModel.value,
                "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                onChange: ($event: any) => (filterCallback()),
                options: $data.statusLabels,
                placeholder: "Vyber stav",
                class: "p-column-filter",
                style: {"min-width":"12rem"},
                showClear: true
              }, {
                option: _withCtx((slotProps) => [
                  _createVNode(_component_Tag, {
                    value: slotProps.option,
                    severity: $options.getStateSeverity(slotProps.option)
                  }, null, 8, ["value", "severity"])
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "Dátum" }, {
            body: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString($options.formatDate(slotProps.data.dateAdd)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("a", {
                onClick: ($event: any) => ($options.showDetail(slotProps.data.id)),
                target: "_blank"
              }, [
                _createVNode(_component_PrimevueButton, {
                  label: "Zobraziť",
                  text: "",
                  raised: "",
                  class: "uppercase",
                  icon: "pi pi-eye",
                  severity: "info"
                })
              ], 8, _hoisted_6)
            ]),
            _: 1
          }),
          _createTextVNode(),
          _createVNode(_component_Column, { header: "" }, {
            body: _withCtx((slotProps) => [
              _createElementVNode("a", {
                onClick: ($event: any) => ($options.deleteOrder(slotProps.data.id)),
                target: "_blank"
              }, [
                _createVNode(_component_PrimevueButton, {
                  label: "Odstrániť",
                  text: "",
                  raised: "",
                  icon: "pi pi-trash",
                  severity: "danger"
                })
              ], 8, _hoisted_7)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rowStyle", "totalRecords", "value", "filters", "onFilter", "loading", "globalFilterFields", "onPage", "rows", "first"])
    ])
  ]))
}